/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Analyze_Extract_DescInputs */

const en_jobs_analyze_extract_desc = /** @type {(inputs: Jobs_Analyze_Extract_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extract structured requirements from the job description using AI.`)
};

const de_jobs_analyze_extract_desc = /** @type {(inputs: Jobs_Analyze_Extract_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strukturierte Anforderungen aus der Stellenbeschreibung mit KI extrahieren.`)
};

const fr_jobs_analyze_extract_desc = /** @type {(inputs: Jobs_Analyze_Extract_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extraire les exigences structurées de la description de poste grâce à l'IA.`)
};

const es_jobs_analyze_extract_desc = /** @type {(inputs: Jobs_Analyze_Extract_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extraer requisitos estructurados de la descripción del puesto mediante IA.`)
};

const it_jobs_analyze_extract_desc = /** @type {(inputs: Jobs_Analyze_Extract_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estrai i requisiti strutturati dalla descrizione del lavoro usando l'AI.`)
};

const nl_jobs_analyze_extract_desc = /** @type {(inputs: Jobs_Analyze_Extract_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extraheer gestructureerde vereisten uit de vacaturetekst met AI.`)
};

const pl_jobs_analyze_extract_desc = /** @type {(inputs: Jobs_Analyze_Extract_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyodrębnij ustrukturyzowane wymagania z opisu stanowiska za pomocą AI.`)
};

const fi_jobs_analyze_extract_desc = /** @type {(inputs: Jobs_Analyze_Extract_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poimi rakenteelliset vaatimukset työpaikkakuvauksesta tekoälyllä.`)
};

const da_jobs_analyze_extract_desc = /** @type {(inputs: Jobs_Analyze_Extract_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udtræk strukturerede krav fra jobbeskrivelsen med AI.`)
};

const sv_jobs_analyze_extract_desc = /** @type {(inputs: Jobs_Analyze_Extract_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extrahera strukturerade krav från jobbbeskrivningen med AI.`)
};

/**
* | output |
* | --- |
* | "Extract structured requirements from the job description using AI." |
*
* @param {Jobs_Analyze_Extract_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_analyze_extract_desc = /** @type {((inputs?: Jobs_Analyze_Extract_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Analyze_Extract_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_analyze_extract_desc(inputs)
	if (locale === "fr") return fr_jobs_analyze_extract_desc(inputs)
	if (locale === "es") return es_jobs_analyze_extract_desc(inputs)
	if (locale === "it") return it_jobs_analyze_extract_desc(inputs)
	if (locale === "nl") return nl_jobs_analyze_extract_desc(inputs)
	if (locale === "pl") return pl_jobs_analyze_extract_desc(inputs)
	if (locale === "fi") return fi_jobs_analyze_extract_desc(inputs)
	if (locale === "da") return da_jobs_analyze_extract_desc(inputs)
	if (locale === "sv") return sv_jobs_analyze_extract_desc(inputs)
	return en_jobs_analyze_extract_desc(inputs)
});